module.exports = __webpack_public_path__ + "media/evolve/assets/icons/fontawesome/solid/paperclip-a653cead8fbc54d077a483786e5abf60.svg";